import { CALL_API } from "admin/middlewares/api";

export const USER_FINANCINGS_LIST_GET_REQUEST =
  "USER_FINANCINGS_LIST_GET_REQUEST";
export const USER_FINANCINGS_LIST_GET_SUCCESS =
  "USER_FINANCINGS_LIST_GET_SUCCESS";
export const USER_FINANCINGS_LIST_GET_ERROR = "USER_FINANCINGS_LIST_GET_ERROR";

export function get_account_financings(accountId) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/financings/byaccount?accountId=" + accountId,
      authenticatedRequest: true,
      types: [
        USER_FINANCINGS_LIST_GET_REQUEST,
        USER_FINANCINGS_LIST_GET_SUCCESS,
        USER_FINANCINGS_LIST_GET_ERROR,
      ],
    },
  };
}

export const USER_FINANCING_LIST_CHANGE_PAGE =
  "USER_FINANCING_LIST_CHANGE_PAGE";

export function change_financing_list_page(page, financingType) {
  return {
    type: USER_FINANCING_LIST_CHANGE_PAGE,
    financingType,
    page,
  };
}

export const USER_FINANCING_LIST_CHANGE_FILTER =
  "USER_FINANCING_LIST_CHANGE_FILTER";

export function change_financing_list_filter(key, value, financingType) {
  let filter = {};
  filter[key] = value;

  return {
    type: USER_FINANCING_LIST_CHANGE_FILTER,
    financingType,
    filter,
  };
}

export const USER_FINANCING_CLOSE_REQUEST = "USER_FINANCING_CLOSE_REQUEST";
export const USER_FINANCING_CLOSE_SUCCESS = "USER_FINANCING_CLOSE_SUCCESS";
export const USER_FINANCING_CLOSE_ERROR = "USER_FINANCING_CLOSE_ERROR";

export function close_financing(financingId, shouldUnpublish) {
  let success = shouldUnpublish
    ? { method: close_and_unpublish.bind(this, financingId) }
    : USER_FINANCING_CLOSE_SUCCESS;

  return {
    [CALL_API]: {
      endpoint: "/api/admin/financings/close",
      method: "POST",
      data: { FinancingId: financingId },
      authenticatedRequest: true,
      types: [
        USER_FINANCING_CLOSE_REQUEST,
        success,
        USER_FINANCING_CLOSE_ERROR,
      ],
    },
  };
}

export const USER_FINANCING_OPEN_REQUEST = "USER_FINANCING_OPEN_REQUEST";
export const USER_FINANCING_OPEN_SUCCESS = "USER_FINANCING_OPEN_SUCCESS";
export const USER_FINANCING_OPEN_ERROR = "USER_FINANCING_OPEN_ERROR";

export function open_financing(financingId, shouldPublish) {
  let success = shouldPublish
    ? { method: open_and_publish.bind(this, financingId, open) }
    : USER_FINANCING_OPEN_SUCCESS;

  return {
    [CALL_API]: {
      endpoint: "/api/admin/financings/open",
      method: "POST",
      data: { FinancingId: financingId },
      authenticatedRequest: true,
      types: [USER_FINANCING_OPEN_REQUEST, success, USER_FINANCING_OPEN_ERROR],
    },
  };
}

export const USER_FINANCING_REGISTER_PAYOUT_REQUEST =
  "USER_FINANCING_REGISTER_PAYOUT_REQUEST";
export const USER_FINANCING_REGISTER_PAYOUT_SUCCESS =
  "USER_FINANCING_REGISTER_PAYOUT_SUCCESS";
export const USER_FINANCING_REGISTER_PAYOUT_ERROR =
  "USER_FINANCING_REGISTER_PAYOUT_ERROR";

export function register_financing_payout(financingId) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/financings/confirmloanpayout",
      method: "POST",
      data: {
        FinancingId: financingId,
      },
      authenticatedRequest: true,
      types: [
        USER_FINANCING_REGISTER_PAYOUT_REQUEST,
        USER_FINANCING_REGISTER_PAYOUT_SUCCESS,
        USER_FINANCING_REGISTER_PAYOUT_ERROR,
      ],
    },
  };
}

export const USER_FINANCING_PUBLISH_REQUEST = "USER_FINANCING_PUBLISH_REQUEST";
export const USER_FINANCING_PUBLISH_SUCCESS = "USER_FINANCING_PUBLISH_SUCCESS";
export const USER_FINANCING_PUBLISH_ERROR = "USER_FINANCING_PUBLISH_ERROR";

function open_and_publish(financingId) {
  return (dispatch) => {
    dispatch({
      type: USER_FINANCING_OPEN_SUCCESS,
      financingId,
    });
    dispatch(publish_financing(financingId));
  };
}

export function publish_financing(financingId) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/financings/publish",
      method: "POST",
      data: { FinancingId: financingId },
      authenticatedRequest: true,
      types: [
        USER_FINANCING_PUBLISH_REQUEST,
        USER_FINANCING_PUBLISH_SUCCESS,
        USER_FINANCING_PUBLISH_ERROR,
      ],
    },
  };
}

export const USER_FINANCING_UNPUBLISH_REQUEST =
  "USER_FINANCING_UNPUBLISH_REQUEST";
export const USER_FINANCING_UNPUBLISH_SUCCESS =
  "USER_FINANCING_UNPUBLISH_SUCCESS";
export const USER_FINANCING_UNPUBLISH_ERROR = "USER_FINANCING_UNPUBLISH_ERROR";

function close_and_unpublish(financingId) {
  return (dispatch) => {
    dispatch({
      type: USER_FINANCING_CLOSE_SUCCESS,
      financingId,
    });
    dispatch(unpublish_financing(financingId));
  };
}

export function unpublish_financing(financingId) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/financings/unpublish",
      method: "POST",
      data: { FinancingId: financingId },
      authenticatedRequest: true,
      types: [
        USER_FINANCING_UNPUBLISH_REQUEST,
        USER_FINANCING_UNPUBLISH_SUCCESS,
        USER_FINANCING_UNPUBLISH_ERROR,
      ],
    },
  };
}

export const USER_CANCEL_FINANCING_REQUEST = "USER_CANCEL_FINANCING_REQUEST";
export const USER_CANCEL_FINANCING_SUCCESS = "USER_CANCEL_FINANCING_SUCCESS";
export const USER_CANCEL_FINANCING_ERROR = "USER_CANCEL_FINANCING_ERROR";

export function cancel_financing(financingId) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/financings/cancel",
      method: "POST",
      data: { FinancingId: financingId },
      authenticatedRequest: true,
      types: [
        USER_CANCEL_FINANCING_REQUEST,
        USER_CANCEL_FINANCING_SUCCESS,
        USER_CANCEL_FINANCING_ERROR,
      ],
    },
  };
}

export const USER_FINANCING_PAYOUT_INFO_REQUEST =
  "USER_FINANCING_PAYOUT_INFO_REQUEST";
export const USER_FINANCING_PAYOUT_INFO_SUCCESS =
  "USER_FINANCING_PAYOUT_INFO_SUCCESS";
export const USER_FINANCING_PAYOUT_INFO_ERROR =
  "USER_FINANCING_PAYOUT_INFO_ERROR";

export function get_financing_payout_info(financingId, offerId, assetType) {
  let url =
    assetType == "Undefined"
      ? `/api/admin/financings/mpl/payout-info?financingId=${financingId}`
      : `/api/admin/financings/loanstep/payout-info?financingId=${financingId}&offerId=${offerId}`;
  return {
    [CALL_API]: {
      endpoint: url,
      method: "GET",
      data: { FinancingId: financingId, OfferId: offerId },
      authenticatedRequest: true,
      types: [
        USER_FINANCING_PAYOUT_INFO_REQUEST,
        USER_FINANCING_PAYOUT_INFO_SUCCESS,
        USER_FINANCING_PAYOUT_INFO_ERROR,
      ],
    },
  };
}
